import { strapi } from "@strapi/client";

// Use the local Webpack proxy in development to bypass CORS,
// and the actual CMS URL in production.
export const STRAPI_URL =
  process.env.NODE_ENV === "production" ? "https://cms.refly.co/api" : "https://localhost:3000/api";

/**
 * Returns a configured Strapi Client instance.
 * It automatically picks up the JWT token from localStorage if the user is logged in.
 */
export const getStrapiClient = () => {
  const token = localStorage.getItem("strapi_jwt");
  const organizationId = localStorage.getItem("organization_id");

  const headers: Record<string, string> = {};
  if (organizationId) {
    headers["organization-document-id"] = organizationId;
  }

  return strapi({
    baseURL: STRAPI_URL,
    auth: token || undefined,
    headers,
  });
};
